import React from 'react';
import {Col, Form, Row, Select, Spin} from "antd";
import {useSelector} from "react-redux";
import {useGetVehicleQuery} from "../../../slices/rootApiSlices/vehicleApiSlice";

const SelectVehicle = ({onChange, name}) => {

    const {user} = useSelector((state) => state.auth);
    const {data, error, isLoading} = useGetVehicleQuery(user?.token);

    const onSearch = (value) => {
        console.log('search:', value);
    };

    if (isLoading) {
        return (
            <Row>
                <Col>
                    <Spin />
                </Col>
            </Row>
        );
    }

    if (error) {
        return (
            <div>hata lütfen bekleyiniz</div>
        )
    }

    return (
        <Form.Item label="Araç Seçimi">
            <Select
                name={name}
                disabled={isLoading}
                showSearch
                placeholder="Araç seçiniz"
                optionFilterProp="children"
                onChange={onChange}
                loading={isLoading}
                onSearch={onSearch}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={data !== null ? data?.data.map((item) => {
                    return {
                        value: item.device_id,
                        label: `${item.plateNumber} - ${item.operationNumber}`
                    }
                }) : null}
            />
        </Form.Item>
    );
};

export default SelectVehicle;
